import { useCisShowTours } from "../../data/hooks/useCisShowTours"
import ToursTableComponent from "../_shared/tables/ToursTable"

export default function ToursComponent() {
    const { tours, toursLoading } = useCisShowTours()

    return <ToursTableComponent variant="normal" loading={toursLoading} tours={tours} />
}
